import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ArrayContextTableWidget: WidgetRegistryEntry = {
  name: "ArrayContextTable",
  component: () => import("./array-context-table-widget.component").then((m) => m.ArrayContextTableWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.ArrayContextTableWidgetConfiguration)
};
